import { render } from "./TestPageView.vue?vue&type=template&id=186147ce&scoped=true"
import script from "./TestPageView.vue?vue&type=script&lang=js"
export * from "./TestPageView.vue?vue&type=script&lang=js"

import "./TestPageView.vue?vue&type=style&index=0&id=186147ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186147ce"]])

export default __exports__